import { SECONDS_PER_BLOCK } from '../constants/chain.constants';

const getBlockDatetime = (blockNumber, currentBlock, chainId) => {
  const secondPerBlock = SECONDS_PER_BLOCK[chainId];
  const secondsDelta = Math.abs(blockNumber - currentBlock) * secondPerBlock;
  return new Date(Date.now() + secondsDelta * 1000);
};

export default getBlockDatetime;
